import React from "react";
import { CurrentProjectHeaderContent } from "./CurrentProjectHeaderContent";

type HeaderProps = {};

export const CurrentProjectHeader: React.FC<HeaderProps> = () => {
  return <CurrentProjectHeaderContent />;
};
